<template>
    <div class="container-fluid">
        <section class="content-header p-1" >
            <div class="row mb-2">
                <h3>Configuración Auto-Visitas</h3>
            </div>
        </section>
        <section class="content">
            <div class="card card-default card-tabs" style="margin:0">
                <div class="card-header p-1 pt-1">
                    <ul class="nav nav-pills" ref="tabHeaders">
                        <li  class="nav-item">
                            <a class="nav-link active" href="#general" data-toggle="tab">
                                General
                            </a>
                        </li>
                        <li  class="nav-item">
                            <a @click="cargarOpers" class="nav-link" data-toggle="tab" href="#operarios">
                                Operarios
                            </a>
                        </li>
                        <li  class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#companias">
                                Compañías
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tab-content" ref="tabContents" style=" margin-top: 15px; padding-bottom: 15px;">
                <div v-if="datos" class="tab-pane active container-grid" id="general">
                    <div style="display: grid;">
                        <label for="">Minutos ocupación citas</label>
                        <input type="number" v-model="datos.config.minutos_cita" class="form-control">
                    </div>
                    <div style="display: grid;">
                        <label for="">Maximo horas para primera cita (anulable por SLA de compañía si se configuran SLAs, y en segunda instancia, por configuración autovisitas por compañía)</label>
                        <input type="number" v-model="datos.config.max_horas_primera_cita" class="form-control">
                    </div>
                    <div style="display: grid;">
                        <label for="">Maximo minutos sin concretar una cita reservada</label>
                        <input type="number" v-model="datos.config.max_minutos_sin_realizar_cita" class="form-control">
                    </div>
                    <div style="display: grid;">
                        <label for="">Distancia máxima en km</label>
                        <input type="number" v-model="datos.config.distancia_maxima_km" class="form-control">
                    </div>
                    <div style="display: grid;">
                        <label for="">Máximo tiempo cercanía (en minutos)</label>
                        <input type="number" v-model="datos.config.tiempo_maximo_cercania" class="form-control">
                    </div>
                    <div style="display: grid;">
                        <div style="display:flex; gap: 10px;margin: 10px 0; align-items: center;">
                            <label style="margin: 0;" for="">Texto personalizado SMS</label>
                            <button @click="palabrasClave = true" class="btn btn-secondary btn-sm">Mostrar palabras clave</button>
                        </div>
                        <textarea rows="3" v-model="datos.config.texto_sms" class="form-control"></textarea>
                    </div>
                    <div style="display: flex; gap: 15px; align-items: center; margin: 15px 0;">
                        <label for="" style="margin: 0;">Permitir que el asegurado cambie fecha</label>
                        <input type="checkbox" v-model="datos.config.asegurado_cambia_fecha" v-bind:true-value="1" v-bind:false-value="0">
                    </div>
                    <div style="display: flex; gap: 15px; align-items: center; margin-bottom: 15px;">
                        <label for="" style="margin: 0;">Forzar que las visitas de servicios urgentes sólo puedan ser dadas hoy</label>
                        <input type="checkbox" v-model="datos.config.autovisitas_urgentes_solo_hoy" v-bind:true-value="1" v-bind:false-value="0">
                    </div>
                    <button class="btn btn-primary" @click="guardarDatos">Guardar</button>
                </div>
                <div class="tab-pane container-grid" id="operarios">
                    <OperariosAutoVisitas ref="operariosCalendar" @cambioSinCoords="actualizar" :datos="datos"></OperariosAutoVisitas>
                </div>
                <div v-if="datos" class="tab-pane container-grid" id="companias">
                    <div style="display: grid;">
                        <label for="">Compañías</label>
                        <select class="form-control" v-model="companiaSeleccionada">
                            <option value="0">Todas</option>
                            <option v-for="compania in Object.entries(datos.companyias)" :key="compania[0]" :value="compania[0]">{{ compania[1].nombre }}</option>
                        </select>
                    </div>
                    <div style="display: grid; margin: 15px 0;">
                        <label for="">Especialidades</label>
                        <select class="form-control" v-model="especialidadSeleccionada">
                            <option value="0">Todas</option>
                            <option v-for="especialidad in Object.entries(datos.especialidades)" :key="especialidad[0]" :value="especialidad[0]">{{ especialidad[1].nombre }}</option>
                        </select>
                    </div>
                    <div style="display: grid;">
                        <label for="">Fecha máxima primera cita (horas)</label>
                        <input type="number" v-model="horaMáximaPrimeraCita" class="form-control" 
                            placeholder="Máximo de horas desde asignación expediente hasta primera cita confirmada (en cías sin SLA)">
                    </div>
                    <button style="margin: 15px 0;" class="btn btn-primary" @click="guardarDatosCompanias">Guardar</button>
                    <div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Compañia</th>
                                    <th>Especialidad</th>
                                    <th>Fecha máxima (horas desde inicio)</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="autocompa in autosCompanias" :key="autocompa">
                                    <td>{{ autocompa.companyia }}</td>
                                    <td>{{ autocompa.especialidad }}</td>
                                    <td>{{ autocompa.fecha_max_primera_cita }}</td>
                                    <td><button @click="confirmarEliminar(autocompa)" class="btn btn-sm btn-light"><i class="far fa-trash-alt"></i></button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <Dialog :style="{ width: '40rem' }" @hide="palabrasClave = false" header="Palabras clave" modal
         v-model:visible="palabrasClave">
            <p v-for="clave in datos.palabras_clave" :key="clave">{{ clave }}</p>
        </Dialog>
    </div>
</template>

<script>
import OperariosAutoVisitas from './OperariosAutoVisitas.vue';
import { PwgsApi } from '../../../../services/PwgsApi';
export default {
    components: {
        OperariosAutoVisitas,
    },
    data() {
        return {
            opersVisible:false,
            datos:'',
            palabrasClave:false,
            companiaSeleccionada:'0',
            especialidadSeleccionada:'0',
            horaMáximaPrimeraCita:'',
            calendarioOperariosRenderizado: false,
            autosCompanias:[],
        };
    },
    methods: {
        async actualizar(){
            const api = new PwgsApi();
            var nuevos_datos = await api.get('pwgs-autovisita');
            var sinCoords = nuevos_datos.operarios_sin_coordenadas;
            this.$refs.operariosCalendar.actualizar(sinCoords);
        },
        confirmarEliminar(autocompa){
            this.$confirm.require({
                message: '¿Desea eliminar el registro?',
                header: 'Confirmar',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.eliminarAutoCompania(autocompa);
                },
                reject: () => {
                }
            });
        },
        async guardarDatosCompanias(){
            const api = new PwgsApi();
            try{
                await api.post('pwgs-autovisita/'+this.companiaSeleccionada+'/autovisitas-companias', {
                    id_especialidad: this.especialidadSeleccionada,
                    fecha_max_primera_cita: this.horaMáximaPrimeraCita
                });
                this.autosCompanias = await api.get('pwgs-autovisita/0/autovisitas-companias');
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados', life: 2000 });
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async eliminarAutoCompania(autocompa){
            const api = new PwgsApi();
            try{
                await api.deletebody('pwgs-autovisita/'+autocompa.id_companyia+'/autovisitas-companias', {id_especialidad: autocompa.id_especialidad});
                this.autosCompanias = await api.get('pwgs-autovisita/0/autovisitas-companias');
                this.$toast.add({ severity: 'success', summary: 'Eliminado', detail: 'Registro eliminado', life: 2000 });
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        cargarOpers(){
            if (this.calendarioOperariosRenderizado) return;
            this.$nextTick(() => {
                    setTimeout(() => {
                        const ref = this.$refs.operariosCalendar;
                        if (ref && typeof ref.forzarRenderCalendario === 'function') {
                            ref.forzarRenderCalendario();
                            this.calendarioOperariosRenderizado = true;
                        }
                    }, 100);
                });
        },
        async guardarDatos(){
            const api = new PwgsApi();
            try{
                var body = {
                    minutos_cita: parseInt(this.datos.config.minutos_cita),
                    max_horas_primera_cita: parseInt(this.datos.config.max_horas_primera_cita),
                    max_minutos_sin_realizar_cita: parseInt(this.datos.config.max_minutos_sin_realizar_cita),
                    distancia_maxima_km: parseInt(this.datos.config.distancia_maxima_km),
                    tiempo_maximo_cercania: parseInt(this.datos.config.tiempo_maximo_cercania),
                    texto_sms: this.datos.config.texto_sms,
                    asegurado_cambia_fecha: this.datos.config.asegurado_cambia_fecha,
                    autovisitas_urgentes_solo_hoy: this.datos.config.autovisitas_urgentes_solo_hoy
                };
                await api.put('pwgs-autovisita', body);                
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados', life: 2000 });               
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async obtenerDatos(){
            const api = new PwgsApi();
            this.datos = await api.get('pwgs-autovisita');
            this.autosCompanias = await api.get('pwgs-autovisita/0/autovisitas-companias');
        }
    },
    mounted() {
        this.obtenerDatos();
    }
};
</script>

<style scoped>

</style>
